import api from '@/api';
import store from '@/store';

const resource = 'ei/turma';

export default {
  getSelectTurmasProfessor(data) {
    return api.get(`${resource}/select-turmas-professor`, {
      params: data,
    });
  },
  getTurmasProfessorDisciplina(data) {
    return api.get(`${resource}/turmas-professor-disciplina`, {
      params: {...
        data,
        identificadorperfilatual: store.getters.userDadosPerfilAtual.identificadorperfil
      },
    });
  },
  getSelectTurmasPerfil(data) {
    return api.get(`${resource}/select-turmas-perfil`, {
      params: {...data,
      identificadorperfilatual: store.getters.userDadosPerfilAtual.identificadorperfil},
    });
  },
  getSelectTurmasUmProfessor(data) {
    return api.get(`${resource}/turmas-um-professor`, {
      params: data,
    });
  },
  getEnturmacao(data) {
    return api.get(`${resource}/enturmacao`, {
      params: data,
    });
  },
  getTurmasDaDisciplinaEPeriodoAvaliativo(data) {
    return api.get(`${resource}/turmas-da-disciplina-periodo-avaliativo`, {
      params: data,
    });

  },
  turmas(data) {
    return api.get(`${resource}/por-escola`, { params: data });
  },
};
